module.exports = __webpack_public_path__ + "8eb7905e59819742ae7bc8c32090e1ca.pdf";